import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {CommandUtil} from '../../../global/commandutil';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {environment} from '../../../../environments/environment';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {MauVanBanFile} from '../../../models/info/mauvanbanfile';
import {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import {KeHoach} from '../../../models/kehoach/kehoach';
import {LoaiKeHoach} from '../../../models/danhmuc/loaikehoach';
import {KeHoachService} from '../../../service/kehoach/service-kehoach';
import {KeHoachFileService} from '../../../service/kehoach/service-kehoachfile';
import {LoaiKeHoachService} from '../../../service/danhmuc/service-loaikehoach';

import {EditKeHoachComponent} from './edit.component';
import {NavItemService} from '../../../service/staff/service-navitem';
import {Sessioncommand} from '../../../global/sessioncommand';
import {DetailKeHoachComponent} from './detail.component';

@Component({
  templateUrl: './kehoach.component.html',
  encapsulation: ViewEncapsulation.None
})
export class KeHoachComponent implements OnInit, AfterViewInit {
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public configToolbar: Object = environment.configToolbar;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public dataList: KeHoach[];
  public submitValidate = false;
  public srTenKeHoach: string = '';
  public srLoaiKeHoach: number = -1;
  public editor = ClassicEditor;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public permissionCNKeHoach: boolean = false;
  public permissionViewKeHoach: boolean = false;
  public staffId: number = Sessioncommand.staffId;
  public dataLoaiKeHoach: LoaiKeHoach[];
  constructor( public keHoachService: KeHoachService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public keHoachFileService: KeHoachFileService,
               public loaiKeHoachService: LoaiKeHoachService,
               public commandUtil: CommandUtil,
               public navItemService: NavItemService

  ) {
  }
  ngAfterViewInit() {

  }
  public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );
  }
  ngOnInit(): void {
    this.search();
    this.loaiKeHoachService.getAll().subscribe(dataLoaiKeHoach => this.dataLoaiKeHoach = dataLoaiKeHoach);
    this.uploadUrl= this.keHoachFileService.urlUpload;
    this.deleteUrl= this.keHoachFileService.urlDelete;
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0050,0051", true).subscribe(
      x => {
        this.permissionCNKeHoach = x>0? true: false;
      }
    );
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0052", true).subscribe(
      x => {
        this.permissionViewKeHoach = x>0? true: false;
      }
    );

  }

  public showConfirmationModal(id: number): void {
    if(this.permissionCNKeHoach) {
      const modal = this.bsModalService.show(ConfirmDialogComponent);
      (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        language.confirm_delete_question,
        language.yes,
        language.no
      );
      (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          this.deleteItem(id);
        }
      });
    }
  }

  public edit(id: number): void {
    if(this.permissionCNKeHoach) {
      const modalEdit = this.bsModalService.show(EditKeHoachComponent, {class: 'modal-lg'});
      (<EditKeHoachComponent>modalEdit.content).edit(
        id
      );
      (<EditKeHoachComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true) {
          this.search();

        }
      });
    }
  }
  search()
  {

    this.keHoachService.findAllByPaging(this.srTenKeHoach, this.srLoaiKeHoach, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.keHoachService.getCountByKeyword(this.srTenKeHoach, this.srLoaiKeHoach, Sessioncommand.staffId).subscribe(recordCount => this.totalItems = recordCount);
  }
  public detail(id: number): void {
    if(this.permissionCNKeHoach || this.permissionViewKeHoach) {
      const modalEdit = this.bsModalService.show(DetailKeHoachComponent, {class: 'modal-lg'});
      (<DetailKeHoachComponent>modalEdit.content).edit(
        id
      );
      (<DetailKeHoachComponent>modalEdit.content).onClose.subscribe(result => {

      });
    }else
    {
      this.toastr.error(language.message_permission_kehoach, language.message);
    }
  }
  deleteItem(id: number)
  {
    this.keHoachService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

